import { PayloadAction, createSlice, noopReducer } from 'ngrx-slice';

import { MerchantCountResponse } from '@app/api/marketplace/models';

export interface State {
  // Merchants count
  merchantCount: number;
  merchantCountError: boolean;
}

export const initialState: State = {
  // merchants
  merchantCount: 0,
  merchantCountError: false,
};

export const {
  actions: SidenavActions,
  selectors,
  ...SidenavFeature
} = createSlice({
  name: 'sidenav',
  initialState,
  reducers: {
    getMerchantCount: {
      trigger: noopReducer(),
      success: (state, action: PayloadAction<MerchantCountResponse>) => ({
        ...state,
        merchantCount: action.merchantCount,
        merchantCountError: false,
      }),
      failure: (state) => ({
        ...state,
        merchantCountError: true,
      }),
    },
  },
});

export const SidenavSelectors = {
  ...selectors,
};
